import { render, staticRenderFns } from "./ProjectPropertiesForm.vue?vue&type=template&id=1e924ad1&scoped=true&"
import script from "./ProjectPropertiesForm.vue?vue&type=script&lang=ts&"
export * from "./ProjectPropertiesForm.vue?vue&type=script&lang=ts&"
import style0 from "./ProjectPropertiesForm.vue?vue&type=style&index=0&id=1e924ad1&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e924ad1",
  null
  
)

export default component.exports